<template>
  <div class="container" @click="bindClick">
    <div class="loading">
      <img
        class="pic"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ccfa8281ff6938964bf2cc4b07736aac.png"
        alt=""
      />
      <div class="text" v-if="type == 'create'">方案生成中…</div>
      <div class="text" v-if="type == 'loading'">加载中...</div>
      <div class="line-container" v-if="type != 'loading'">
        <div
          class="percent"
          :style="{
            width: percent + '%',
            transition: 'width ' + this.delayTime / 1000 + 's linear'
          }"
          ref="percent"
        >
          <div class="linear-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      percent: 0,
      type: 'loading',
      delayTime: 2000
    }
  },
  computed: {
    ...mapState('drinkWater', ['cupType', 'waterId'])
  },
  created() {
    let type = this.$route.query.type
    if (type) {
      this.type = type
    }
  },
  mounted() {
    if (this.type == 'create') {
      setTimeout(() => {
        this.$refs.percent.addEventListener('transitionend', () => {
          this.$router.replace('/drink-water-reminder/index')
        })
        this.percent = 100
      }, 200)
    } else {
      this.getCupType()
    }
  },
  methods: {
    //因为该页面没有任何按钮 而app登录在旧版本没有回调，所以给整个页面加上点击事件
    bindClick() {
      this.$betterwe.isLogin(() => {
        this.getCupType()
      })
    },
    //获取水杯类型
    getCupType() {
      this.$http
        .getBaseApp('api/v2/WaterRemind/judgeUserInUseWaterPlan', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let cupType = res.data.use_version
            this.$store.commit('drinkWater/setWaterId', res.data.id)
            if (cupType == 1) {
              this.getRainbowData()
            } else {
              this.bindToHome()
            }
          } else if (res.code == 410) {
            this.$betterwe.isLogin(() => {
              this.getCupType()
            })
          } else if (res.code == 414) {
            this.createPlan()
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //生成普通杯喝水方案
    createPlan() {
      this.$http
        .getBaseApp('api/v2/WaterRemind/createGenericWaterPlan', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$store.commit('drinkWater/setWaterId', res.data)
            this.bindToHome()
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //去普通杯喝水首页
    bindToHome() {
      let params = {
        water_user_id: this.waterId
      }
      this.$http
        .getBaseApp('api/v2/WaterRemind/getGenericWaterPlan', params)
        .then((res) => {
          res = res.data
          this.$store.commit('drinkWater/setDrinkData', res.data)
          this.$router.replace('/drink-water-reminder/normal/index')
        })
    },
    //获取彩虹杯数据
    getRainbowData() {
      let promise1 = this.$http.getBaseApp(
        'member/WaterClock/getWaterUserIdentity',
        {}
      )
      let promise2 = this.$http.getBaseApp(
        'member/WaterClock/getUserProject',
        {}
      )
      Promise.all([promise1, promise2])
        .then((resArr) => {
          let res0 = resArr[0].data
          let res1 = resArr[1].data
          if (res0.code == 200 && res1.code == 200) {
            let str = res0.data.data == 1 ? '0' : '1'
            localStorage.setItem('first-show-dirnk-plan' + this.cupType, str)
            localStorage.setItem('drink-tutorial' + this.cupType, str)
            this.$store.commit('drinkWater/setDrinkData', res1.data)
            if (this.type == 'back') {
              this.$router.go(-1)
            } else {
              this.$router.replace('/drink-water-reminder/index')
            }
          } else if (res0.code == 200 && res1.code !== 200) {
            this.$router.replace('/drink-water-reminder/fill')
          } else if (res0.code == 403 && res1.code == 403) {
            this.$toast(res0.msg)
          } else if (res0.code == 204 || res1.code == 204) {
            //未登录
            this.$betterwe.isLogin(() => {
              this.getCupType()
            })
          } else {
            this.$router.replace('/drink-water-reminder/start')
          }
        })
        .catch((res) => {
          this.$toast('异常错误')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100vh;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .pic {
    width: 56px;
    height: 100px;
    object-fit: contain;
    margin-bottom: 30px;
  }

  .text {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .line-container {
    width: 270px;
    height: 4px;
    background: #eeeeee;

    .percent {
      width: 0%;
      height: 100%;
      overflow: hidden;
      border-radius: 5px;

      .linear-line {
        width: 270px;
        height: 100%;
        background: linear-gradient(
          90deg,
          #ffd9d9 0%,
          #ee5165 14.2%,
          #ff9854 28.4%,
          #ffbd01 42.6%,
          #4cf8b7 56.8%,
          #32cdff 71%,
          #306dff 85.2%,
          #d048ff 100%
        );
      }
    }
  }
}
</style>
